import { render, staticRenderFns } from "./m-versions.vue?vue&type=template&id=121269df&"
import script from "./m-versions.vue?vue&type=script&lang=js&"
export * from "./m-versions.vue?vue&type=script&lang=js&"
import style0 from "./m-versions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports